var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group',_vm._b({staticClass:"alert-danger"},'b-list-group',_vm.$attrs,false),_vm._l((_vm.errors),function(error,index){return _c('b-list-group-item',{key:index,attrs:{"variant":"danger","error":error}},[(error.error)?_c('span',[_vm._v(_vm._s(error.error))]):_c('span',[_vm._v(_vm._s(error))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }